import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './index.css'
import VueWow from 'vue-wow'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAlignLeft, faAngleLeft, faEye, faCheck, faEyeSlash, faTimes, faBars, faPlusSquare, faCircle, faAngleDown, faTrash, faPlayCircle, faPlus, faUserPlus, faTimesCircle, faTags, faArrowRight, faArrowLeft, faCalendarAlt, faGlobeAfrica, faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueAnalytics from 'vue-analytics';
import baseURL from './apiBase'

library.add(faAlignLeft, faAngleLeft, faEye, faCheck, faEyeSlash, faTimes, faBars, faPlusSquare, faCircle, faAngleDown, faTrash, faPlayCircle, faPlus, faUserPlus, faTimesCircle, faTags, faArrowRight, faArrowLeft, faCalendarAlt, faGlobeAfrica, faFacebook, faTwitter, faLinkedin, faCheckCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)



//After login, on page refresh, set authorization header
const token = localStorage.getItem('user-token')
if(token){
  store.state.userState = 'logged in'
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

Vue.config.productionTip = false


// Configuration VueAnalytics
Vue.use(VueAnalytics, {
	id: 'UA-137027779-1',
  router
});

Vue.use(VueWow)

if (!store || typeof store.commit !== 'function' || typeof store.dispatch !== 'function') {
  // eslint-disable-next-line no-console
  console.error('[main.js] store did not resolve correctly, aborting mount.', store)
} else {
  let privateStoreRef = store
  Object.defineProperty(Vue.prototype, '$store', {
    configurable: true,
    enumerable: true,
    get() {
      return (this.$root && this.$root.$options && this.$root.$options.store)
        ? this.$root.$options.store
        : privateStoreRef
    },
    set(val) {
      privateStoreRef = val
    }
  })
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}


export default baseURL
